import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Carousel } from 'react-bootstrap';
import UploadFileModal from '../UploadFileModal/UploadFileModal';
import PageLoaderSpinner from '../PageLoaderSpinner/PageLoaderSpinner';
import './ImageCarousel.scss';

const ImageCarousel = ({
  mainImageAddedCallback,
  additionalImagesAddedCallback,
  initialImages,
}) => {
  const [images, setImages] = useState(initialImages);
  const [isLoading, setIsLoading] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [isRightArrowShown, setIsRightArrowShown] = useState(true);
  const [isLeftArrowShown, setIsLeftArrowShown] = useState(true);
  useEffect(() => {
    setIsLeftArrowShown(activeIndex < images.length - 1);
    setIsRightArrowShown(activeIndex > 0);
  }, [activeIndex]);
  useEffect(() => {
    if (images.length === 1) {
      mainImageAddedCallback(images[0].id);
      additionalImagesAddedCallback([]);
    } else if (images.length > 1) {
      mainImageAddedCallback(images[0].id);
      const additionalImagesIds = images
        .filter(image => images[0].id !== image.id)
        .map(image => image.id);
      additionalImagesAddedCallback(additionalImagesIds);
    } else {
      mainImageAddedCallback(undefined);
      additionalImagesAddedCallback([]);
    }
  }, [images]);
  // const navigateToImage = (index) => {
  //   setActiveIndex(index);
  // };
  const handleSlide = (direction) => {
    if (direction === 'right') {
      if (activeIndex - 1 >= 0) {
        setActiveIndex(prevState => prevState - 1);
      }
      return;
    }
    if (direction === 'left') {
      if (activeIndex + 1 <= images.length) {
        setActiveIndex(prevState => prevState + 1);
      }
      return;
    }

    setActiveIndex(direction);
  };
  const handleMainImageUploaded = (img) => {
    setImages(prevState => [...prevState, img]);
    const newLength = images.length + 1;
    setActiveIndex(activeIndex < newLength ? images.length : 0);
    setIsLoading(false);
  };
  const deleteImage = (img) => {
    setImages(images.filter(image => image.id !== img.id));
    if (activeIndex > 0) {
      setActiveIndex(prevState => prevState - 1);
    } else {
      setActiveIndex(0);
    }
  };
  return (
    <div className="position-relative">
      {images.length > 0 && (
        <>
          <div className="carousel-container">
            <Carousel
              className="w-100 h-100"
              controls={false}
              indicators={false}
              pause
              onSlid={handleSlide}
              activeIndex={activeIndex}
            >
              {images.map(img => (
                <Carousel.Item key={img.id}>
                  <>
                    <img
                      className="carousel-image"
                      onLoad={e => e.target.classList.add('after-loading')}
                      src={img.url}
                      alt="Art Item Figure"
                    />
                    <button
                      type="button"
                      className="delete-image-btn"
                      onClick={() => deleteImage(img)}
                    >
                      <img
                        src="/images/delete-icon.svg"
                        className="img-fluid"
                        alt=""
                        height="16"
                        width="16"
                      />
                    </button>
                  </>
                </Carousel.Item>
              ))}
            </Carousel>
          </div>
          <div className="buttons-container">
            <button type="button" className="carousel-button" onClick={() => handleSlide('right')}>
              {isRightArrowShown && (
                <img alt="Next Figure" className="img-fluid" src="/images/left-arrow.svg" />
              )}
            </button>
            <button type="button" className="carousel-button" onClick={() => handleSlide('left')}>
              {isLeftArrowShown && (
                <img alt="Previous Figure" className="img-fluid" src="/images/right-arrow.svg" />
              )}
            </button>
          </div>
        </>
      )}
      {images.length === 0 && !isLoading && (
        <div className="no-artwork-box">
          <span>No images has been uploaded yet.</span>
        </div>
      )}
      {isLoading && (
        <div
          className={`carousel-spinner-container ${images.length === 0 ? 'first-loader' : ''}`}
        >
          <PageLoaderSpinner withOverlay />
        </div>
      )}
      <UploadFileModal
        imagesOnly
        className="upload-new-img d-flex justify-content-center align-items-center"
        uploadInProgressCallback={() => setIsLoading(true)}
        callback={handleMainImageUploaded}
        endpoint="/upload"
      />
    </div>
  );
};

ImageCarousel.propTypes = {
  mainImageAddedCallback: PropTypes.func,
  additionalImagesAddedCallback: PropTypes.func,
  initialImages: PropTypes.arrayOf(PropTypes.any),
};

ImageCarousel.defaultProps = {
  mainImageAddedCallback: undefined,
  additionalImagesAddedCallback: undefined,
  initialImages: [],
};

export default ImageCarousel;
